import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const WrapperCard = styled.div`
  margin-bottom: 24px;
`

export const DateTitle = styled.div`
  font-size: 14px;
  color: ${myPalette.midnightBlue.main};
`

export const Divider = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${myPalette.black.main};
`
